import { AgGridCustomFilterAdapter } from 'components/CustomTableFilter';
import { FactorAppliesToLinkValue } from 'constantsProject';
import type { PriceListRatioUerRowData, RatioRecordStatusEnum } from 'gql/graphql';

import type { ColDef } from 'ag-grid-community';
import { useCallback, useMemo, useState } from 'react';

import {
    uerRatioAppliesToCodeFilter,
    uerRatioAppliesToCodeNameFilter,
    uerRatioAppliesToLinkStatusFilter,
} from '../../PriceListFactors/factorsQueries';

export const useRatioUersColumns = (ratioRowId: number) => {
    const [filterValues, setFilterValues] = useState(undefined);

    const variables = useMemo(
        () => ({
            ratioRowId,
        }),
        [ratioRowId],
    );

    const changeFilterHandler = useCallback((value: { checkedValues: string[]; fieldName: string }) => {
        setFilterValues((prevFilters: any) => ({ ...prevFilters, [value.fieldName]: value.checkedValues }));
    }, []);

    const columns = useMemo<ColDef<PriceListRatioUerRowData>[]>(
        () => [
            {
                field: 'appliesToCode',
                headerName: 'Шифр',
                width: 160,
                filter: AgGridCustomFilterAdapter,
                filterParams: {
                    hideTableHeader: true,
                    variables,
                    changeFilterHandler,
                    dataAccessor: 'uerRatioAppliesToCodeFilter',
                    whereVariables: ['value'],
                    childFieldAccessor: 'value',
                    columns: [
                        {
                            headerName: 'Шифр',
                            field: 'value',
                            checkboxSelection: true,
                            width: 400,
                        },
                    ],
                    query: uerRatioAppliesToCodeFilter,
                },
            },
            {
                field: 'appliesToCodeName',
                headerName: 'Наименование',
                width: 760,
                flex: 1,
                filter: AgGridCustomFilterAdapter,
                filterParams: {
                    hideTableHeader: true,
                    variables,
                    changeFilterHandler,
                    dataAccessor: 'uerRatioAppliesToCodeNameFilter',
                    whereVariables: ['value'],
                    childFieldAccessor: 'value',
                    columns: [
                        {
                            headerName: 'Наименование',
                            field: 'value',
                            checkboxSelection: true,
                            width: 400,
                        },
                    ],
                    query: uerRatioAppliesToCodeNameFilter,
                },
            },
            {
                field: 'appliesToLinkStatus',
                headerName: 'Статус связи',
                minWidth: 200,
                flex: 0,
                valueFormatter: ({ value }) => FactorAppliesToLinkValue[value] ?? '',
                filter: AgGridCustomFilterAdapter,
                filterParams: {
                    hideTableHeader: true,
                    withSearch: false,
                    variables,
                    changeFilterHandler,
                    dataAccessor: 'uerRatioAppliesToLinkStatusFilter',
                    whereVariables: ['value'],
                    childFieldAccessor: 'value',
                    columns: [
                        {
                            headerName: 'Статус связи',
                            field: 'value',
                            checkboxSelection: true,
                            width: 400,
                            valueFormatter: ({ value }: { value: RatioRecordStatusEnum }) =>
                                FactorAppliesToLinkValue[value],
                        },
                    ],
                    query: uerRatioAppliesToLinkStatusFilter,
                },
            },
        ],
        [changeFilterHandler, variables],
    );

    return {
        columns,
        filterValues,
    };
};
